const GVdata = [
	{
		img:"g1",
		name: "Cards slider design",
		types: ["experimental"],
		state: "100",
		github: "www.github.com",
		tools: ["html 5", "css 3", "javascript"]
	},
	{
		img:"g2",
		name: "Contact us section design",
		types: ["blog"],
		state: "100",
		github: "www.github.com",
		tools: ["React"]
	},
	{
		img:"g3",
		name: "Portfolio design for video editor",
		types: ["experimental"],
		state: "done",
		github: "www.github.com",
		tools: ["html 5", "css 3", "javascript"]
	},
	{
		img:"g4",
		name: "Websit for a pizzeria",
		types: ["blog", "store"],
		state: "done",
		github: "www.github.com",
		tools: ["React"]
	},
	{
		img:"g5",
		name: "Website for web hosting compagny",
		types: ["blog", "store"],
		state: "50",
		github: "www.github.com",
		tools: ["html 5", "css 3", "javascript"]
	},
	{
		img:"g6",
		name: "Website design for web hosting service",
		types: ["blog", "store"],
		state: "done",
		github: "www.github.com",
		tools: ["React", "Express", "rest api"]
	},
	{
		img:"g7",
		name: "A oceanic shipping compagny",
		types: ["blog", "store", "clone"],
		state: "done",
		github: "www.github.com",
		tools: ["html 5", "css 3", "javascript"]
	},
	{
		img:"g8",
		name: "Portfolio design for a story-writer ",
		types: ["blog", "experimental"],
		state: "done",
		github: "www.github.com",
		tools: ["html 5", "css 3", "javascript"]
	},
	{
		img:"g9",
		name: "Shopping cart design with React & redux",
		types: ["store"],
		state: "done",
		github: "www.github.com",
		tools: ["Express", "EJS Engine"]
	},
	{
		img:"g10",
		name: "Secret documment website",
		types: ["blog"],
		state: "done",
		github: "www.github.com",
		tools: ["React"]
	},
	{
		img:"g11",
		name: "Home page for Crypto exchange website",
		types: ["blog", "store"],
		state: "80",
		github: "www.github.com",
		tools: ["React", "Express", "GraphQL", "Apollo"]
	},
	{
		img:"g12",
		name: "Github clone but modified",
		types: ["blog", "experimental"],
		state: "40",
		github: "www.github.com",
		tools: ["React"]
	},
	{
		img:"g13",
		name: "Store design built with redux",
		types: ["blog", "store"],
		state: "60",
		github: "www.github.com",
		tools: ["React", "redux"]
	},
	{
		img:"g14",
		name: "basic fullstack Next.js app",
		types: ["experimental"],
		state: "done",
		github: "www.github.com",
		tools: ["Next"]
	},
	{
		img:"g15",
		name: "A design for a login page",
		types: ["blog"],
		state: "done",
		github: "www.github.com",
		tools: ["React", "Redux"]
	},
	{
		img:"g16",
		name: "Online chat app",
		types: ["chat"],
		state: "80",
		github: "www.github.com",
		tools: ["React", "Express", "SocketIO", "MongoDB", "Firebase", "Redis"]
	}
]

export default GVdata